/**
 * Medidas do campo, em metros (GDD, seções 2 e 8). O campo é uma elipse; x vai de um gol ao outro,
 * z é a largura e y é a altura. A origem fica no centro do gramado.
 */
export const PITCH = {
  /** Semieixos da elipse do gramado. */
  radiusX: 70,
  radiusZ: 45,
  /** Faixa de areia entre o gramado e a arquibancada (semieixos externos). */
  sandRadiusX: 75.5,
  sandRadiusZ: 49.5,
  /** Distância do centro até a linha dos aros de cada lado. */
  hoopX: 57,
  /** Os 3 aros de cada lado: posição na largura e altura do centro do aro. */
  hoops: [
    { z: -8, height: 14.6 },
    { z: 0, height: 18.6 },
    { z: 8, height: 14.6 },
  ],
  hoopRadius: 2.6,
  /** Área do goleiro: meia-elipse à frente dos aros (semieixos em x e z). */
  keeperAreaX: 15,
  keeperAreaZ: 18,
  centerCircleRadius: 7,
  /** Teto de voo. */
  ceiling: 40,
} as const;

/** Lado do campo: -1 é o dos mandantes (x negativo), 1 o dos visitantes. */
export type Side = -1 | 1;

/** Centro de cada aro de um lado, em metros. */
export function hoopCenters(side: Side): { x: number; y: number; z: number }[] {
  return PITCH.hoops.map((h) => ({ x: side * PITCH.hoopX, y: h.height, z: h.z }));
}

/** Se o ponto (x, z) está dentro da elipse do gramado. */
export function insidePitch(x: number, z: number): boolean {
  return (x / PITCH.radiusX) ** 2 + (z / PITCH.radiusZ) ** 2 <= 1;
}

/**
 * Escala de exibição dos atletas no estádio. Corpo e proporções continuam humanos (1,60 a 1,90 m), mas,
 * vistos de cima num campo de 140 m, aparecem 2,45 vezes maiores, como na cena de referência.
 */
export const ATHLETE_VIEW_SCALE = 2.45;
